// Priority column: priority pill (read) / priority ComboSelect (edit).
import { GoalPriorityChip } from '../../../components/molecules';
import { GoalInlineRow } from '../goalInlineHelpers';
import { PriorityEditSelect, GoalRowCtx } from './shared';

export const PriorityCellRead = ({ row }: { row: GoalInlineRow }) => {
    if (!row.goalPriority) return null;
    return <GoalPriorityChip goalPriority={row.goalPriority} />;
};

export const PriorityCellEdit = ({ ctx }: { ctx: GoalRowCtx }) => <PriorityEditSelect ctx={ctx} />;
